var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#1277d1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,12a21.823,21.823,0,0,1-1.387,8.1,7.158,7.158,0,0,1-1.379,2.254A1.779,1.779,0,0,1,12,23a1.779,1.779,0,0,1-1.234-.645A7.157,7.157,0,0,1,9.388,20.1,21.823,21.823,0,0,1,8,12,21.823,21.823,0,0,1,9.388,3.9a7.157,7.157,0,0,1,1.379-2.255A1.779,1.779,0,0,1,12,1a1.779,1.779,0,0,1,1.234.645A7.157,7.157,0,0,1,14.613,3.9,21.823,21.823,0,0,1,16,12Z",
    fill: "none",
    stroke: "#1277d1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    transform: "translate(1 14)",
    fill: "#1277d1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    transform: "translate(1 8)",
    fill: "#1277d1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalization);
export default __webpack_public_path__ + "static/media/localization.f8bbfb1892c9834fc0cb9abb11a6ae69.svg";
export { ForwardRef as ReactComponent };